//@flow
import React from 'react';
import Dialog from 'common/components/core/dialog';
import { themr } from 'react-css-themr';
import { compose } from 'recompose';
import { translate } from 'react-i18next';

import defaultTheme from 'common/entity/teamMaster/EnableTeamModal.scss';

import type { TFunction } from 'react-i18next';
import { clientSelector } from 'common/redux/selectors/queryParamsSelectors';
import { connect } from 'react-redux';
import { withRouter } from 'common/components/core/router';
import HomebaseIdInput from 'common/entity/homebaseMaster/HomebaseIdInput';
import HomebaseActions from 'common/redux/actions/homebaseMaster';
import { HomebaseStatusEnum } from 'common/models/internal/MasterHomebase';
import { FilterBuilder, FilterOperation } from 'common/models/internal/Filter';
import DataUtils from 'common/utils/DataUtils';
import FilterListBuilder from 'common/models/helpers/FilterListBuilder';
import type { MasterHomebaseModelType } from 'common/models/flow/MasterHomebase';
import { ENTITY_NAME_ID } from 'common/constants/entity/homebaseMaster';

type Props = {
    theme: Object,
    clientId: string,
    toggleView: () => void,
    enableEntity: ({ clientId: string, homebaseId: string }) => Promise<void>,
    reloadData: () => void,
    t: TFunction
};

type State = {
    selectedHomebase: ?MasterHomebaseModelType
};

class EnableHomebaseModal extends React.PureComponent<Props, State> {
    state = {
        selectedHomebase: null
    };

    handleAccept = () => {
        const { toggleView, enableEntity, clientId, reloadData } = this.props;
        const homebaseId = this.state.selectedHomebase?.id;
        if (homebaseId) {
            enableEntity({ clientId, homebaseId })
                .then(toggleView)
                .then(reloadData)
                .catch(toggleView);
        } else {
            toggleView();
        }
    };

    setSelectedHomebase = selectedHomebase => {
        this.setState({ selectedHomebase });
    };

    homebaseInputFilters = input => {
        let filters = new FilterListBuilder().addAll([
            new FilterBuilder()
                .withName('status')
                .withOperation(FilterOperation.Equals)
                .withValue(HomebaseStatusEnum.Inactive)
        ]);
        if (!DataUtils.isEmpty(input)) {
            filters = filters.add(
                new FilterBuilder()
                    .withName('id')
                    .withOperation(FilterOperation.ContainsToken)
                    .withValue(input)
            );
        }
        return filters.build();
    };

    render() {
        const { theme, t, toggleView, clientId } = this.props;
        const entityNameId = ENTITY_NAME_ID;
        const enableEntity = t('enableEntity', {
            entityNameId
        });
        const { selectedHomebase } = this.state;
        return (
            <Dialog
                title={enableEntity}
                theme={theme}
                active
                acceptActionLabel={enableEntity}
                onAccept={this.handleAccept}
                onCancel={toggleView}
                onDismiss={toggleView}
            >
                <h4>
                    {t('disabledEntity', {
                        entityNameId: 'homebase'
                    })}
                    :
                </h4>
                <HomebaseIdInput
                    clientId={clientId}
                    value={selectedHomebase}
                    onChange={this.setSelectedHomebase}
                    homebaseInputFilters={this.homebaseInputFilters}
                    placeholder={t(
                        'homebaseMasterTable.enableHomebasePlaceholder'
                    )}
                />
            </Dialog>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const clientId = clientSelector(state, ownProps);
    return {
        clientId
    };
};

const withRedux = connect(mapStateToProps, {
    enableEntity: HomebaseActions.enableEntity
});

export default compose(
    withRouter,
    withRedux,
    themr('EnableHomebaseModal', defaultTheme),
    translate('entityManagement')
)(EnableHomebaseModal);
